import script from "./CreateIpdBilling.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateIpdBilling.vue?vue&type=script&setup=true&lang=js"

import "./CreateIpdBilling.vue?vue&type=style&index=0&id=432610bd&lang=css"
import "./CreateIpdBilling.vue?vue&type=style&index=1&id=432610bd&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-432610bd"]])

export default __exports__